import React from "react";

import { Link } from "gatsby";
import { useSiteMetadata } from "../../hooks/defaults/Use-SiteMetadata";
import { useMainCTA } from "../../hooks/defaults/Use-CTA";
import tw, { css } from "twin.macro";
import { useReplaceDefaults } from "../../utils/use-Replace-Defaults";

const CTAOne = ({ Heading, subHeading, phone_number, ...props }) => {
	const { phoneNum } = useSiteMetadata();
	const { subheading, heading } = useMainCTA();
	const defaultNum = phone_number ? phone_number : phoneNum;
	const defaultHeading = Heading ? Heading : heading;
	const defaultSubheading = subHeading ? subHeading : subheading;
	if (props?.link_site) {
		if (!props?.link_site.includes("https://")) {
			props.link_site = "https://" + props.link_site;
		}
	}

	return (
		<>
			<div
				css={[
					props?.background ? tw`bg-slate-100 shadow border-t-8` : "",
					/* Combine regular css and Tailwind styles within backticks */
				]}
			>
				<div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-6 ">
					<div
						css={[
							tw`bg-slate-800 via-blue-300 to-white  p-10 rounded outline outline-[4px] hover:outline-[5px] outline-blue-500/20 hover:outline-blue-500/80 outline-offset-[6px] hover:outline-offset-0 duration-300 `,
							/* Combine regular css and Tailwind styles within backticks */
						]}
					>
						<div className="grid grid-cols-2 md:grid-cols-6   gap-8">
							<div className="col-span-6 sm:col-span-4 items-center justify-between">
								<div className="drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
									<h1 className=" text-2xl md:text-3xl text-white  ">
										{useReplaceDefaults({
											text: defaultHeading,
											phone_number: defaultNum,
										})}
									</h1>
									<p className=" mt-1 font-thin md:text-xl text-white">
										{useReplaceDefaults({
											text: defaultSubheading,
											phone_number: defaultNum,
										})}
									</p>
								</div>
							</div>
							<div className="col-span-6 sm:col-span-2  flex my-auto ">
								{props?.callNow ? (
									<a
										className="w-full text-center text-white rounded bg-blue-500/90 outline outline-[0.1px] outline-offset-[6px] hover:outline-offset-0 hover:bg-blue-700/80 duration-150 p-3 "
										href={`tel:+${defaultNum}`}
									>
										{defaultNum}
									</a>
								) : props?.link_site ? (
									<a
										href={props.link_site}
										className="w-full text-center text-white rounded bg-blue-500/90 outline outline-[0.1px] outline-offset-[6px] hover:outline-offset-0 hover:bg-blue-700/80 duration-150 p-3 "
									>
										{props?.link_company_name
											? props?.link_company_name
											: "Contact Us"}
									</a>
								) : (
									<Link
										to="/quote"
										className="w-full text-center text-white rounded bg-blue-500/90 outline outline-[0.1px] outline-offset-[6px] hover:outline-offset-0 hover:bg-blue-700/80 duration-150 p-3 "
									>
										Get A Quote
									</Link>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default CTAOne;
